var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"mb-1",attrs:{"align":"center","justify":"center","justify-md":"start"}},[_c('v-img',{attrs:{"src":_vm.cardBrand,"max-height":"20","max-width":"35","alt":"img","contain":""}}),_vm._v(" "),_c('div',{staticClass:"small-label"},[_vm._v("\n    "+_vm._s(_vm.cardNumber)+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a3713b6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Payment/PaymentCardField.vue
// module id = null
// module chunks = 